import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "NotFoundReference";
var classes = {
    chipFound: "".concat(PREFIX, "-chipFound"),
    chipNotFound: "".concat(PREFIX, "-chipNotFound"),
    caption: "".concat(PREFIX, "-caption")
};
var StyledNotFoundReference = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            paddingBottom: theme.spacing(2),
            "& > *": {
                margin: theme.spacing(0.5)
            }
        },
        _b["& .".concat(classes.chipFound)] = {
            color: theme.palette.secondary.contrastText,
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.info.light
        },
        _b["& .".concat(classes.chipNotFound)] = {
            color: theme.palette.secondary.contrastText,
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.warning.light
        },
        _b["& .".concat(classes.caption)] = {
            marginLeft: 0
        },
        _b);
});

export { classes, StyledNotFoundReference as default };
//# sourceMappingURL=index.styled.js.map
